import { runStaggerReveal } from '../animations'

runStaggerReveal({ container: '.lp-how', card: '.lp-how__step' })
runStaggerReveal({ container: '.lp-how2', card: '.lp-how2__step' })
